import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// ==================================================================================
// IMPORTAÇÃO DA API CENTRALIZADA
// ==================================================================================
import api from '../../services/api';

// ============================================================================
// ÍCONES SYSTEM
// ============================================================================
const Icons = {
    Play: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>,
    Stop: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect></svg>,
    Zoom: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>,
    Close: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
    Store: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18v-8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><path d="M7 8V6a5 5 0 0 1 10 0v2"></path></svg>,
    
    // Ícones do Feed
    Radar: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>,
    Scan: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
    Success: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>,
    Skip: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>,
    Error: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>,
    Info: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
};

export default function RoboPosVenda() {
  
  const [logs, setLogs] = useState([]);
  const [isRunning, setIsRunning] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [lojaSelecionada, setLojaSelecionada] = useState('Todas'); // Novo Estado para a Loja
  
  const [stats, setStats] = useState({
    analisados: 0,
    enviados: 0,
    ignorados: 0,
    erros: 0
  });

  const feedEndRef = useRef(null);
  const socketUrl = api.defaults.baseURL || window.location.origin;

  useEffect(() => {
    if (feedEndRef.current) {
      feedEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs]);

  useEffect(() => {
    const socket = io(socketUrl);

    socket.on('robo:log', (data) => {
      setLogs(prev => [...prev, data]);
      
      if (data.tipo === 'analisando') setStats(s => ({ ...s, analisados: s.analisados + 1 }));
      if (data.tipo === 'sucesso') setStats(s => ({ ...s, enviados: s.enviados + 1 }));
      if (data.tipo === 'ignorado' || data.tipo === 'ok') setStats(s => ({ ...s, ignorados: s.ignorados + 1 }));
      if (data.tipo === 'erro') setStats(s => ({ ...s, erros: s.erros + 1 }));

      if (data.tipo === 'info' && data.msg.includes('Iniciando')) setIsRunning(true);
      if (data.tipo === 'finalizado' || (data.tipo === 'erro' && data.msg.includes('ERRO CRÍTICO'))) setIsRunning(false);
    });

    return () => socket.disconnect();
  }, [socketUrl]);

  const iniciarRobo = async () => {
    if (isRunning) return;
    
    // Confirmação simples
    const confirmMsg = lojaSelecionada === 'Todas' 
        ? "Iniciar varredura em TODAS as lojas?" 
        : `Iniciar varredura apenas na ${lojaSelecionada}?`;
        
    if (!window.confirm(confirmMsg)) return;

    setLogs([]); 
    setStats({ analisados: 0, enviados: 0, ignorados: 0, erros: 0 });
    setIsRunning(true);

    try {
      // Agora enviamos a loja no corpo da requisição
      await api.post('/api/whatsapp/api/robo/iniciar', { 
          loja: lojaSelecionada 
      });
    } catch (error) {
      setLogs([{ tipo: 'erro', msg: `Falha de conexão com a Engine: ${error.message}`, hora: new Date().toLocaleTimeString('pt-BR') }]);
      setIsRunning(false);
    }
  };

  const getEventUI = (tipo) => {
      switch (tipo) {
          case 'analisando': return { icon: <Icons.Scan />, color: 'blue', label: 'Escaneando' };
          case 'sucesso': return { icon: <Icons.Success />, color: 'emerald', label: 'Enviado' };
          case 'erro': return { icon: <Icons.Error />, color: 'red', label: 'Falha' };
          case 'ignorado': 
          case 'ok': return { icon: <Icons.Skip />, color: 'slate', label: 'Bypass' };
          case 'finalizado': return { icon: <Icons.Radar />, color: 'purple', label: 'Concluído' };
          default: return { icon: <Icons.Info />, color: 'slate', label: 'Sistema' };
      }
  };

  return (
    <div className="crm-robot-container animate-fade-in">
      
      {/* ================= HERO HEADER ================= */}
      <div className="robot-header">
        <div className="rh-left">
            <div className="rh-brand">
                <div className={`radar-indicator ${isRunning ? 'active' : ''}`}>
                    <div className="radar-core"></div>
                    <div className="radar-wave"></div>
                </div>
                <div>
                    <span className="brand-tag">CRM AUTOMATION</span>
                    <h2>Inteligência de Retenção</h2>
                </div>
            </div>
            <p>Selecione a unidade e inicie a varredura da base de clientes.</p>
        </div>
        
        <div className="rh-right">
            {/* SELETOR DE LOJA INTEGRADO */}
            <div className={`store-selector ${isRunning ? 'disabled' : ''}`}>
                <span className="selector-icon"><Icons.Store /></span>
                <select 
                    value={lojaSelecionada} 
                    onChange={(e) => setLojaSelecionada(e.target.value)}
                    disabled={isRunning}
                >
                    <option value="Todas">Todas as Lojas</option>
                    <option value="Vizum 01">Vizum 01</option>
                    <option value="Vizum 02">Vizum 02</option>
                    <option value="UNIDADE V01">UNIDADE V01</option>
                    <option value="UNIDADE V02">UNIDADE V02</option>
                </select>
                <span className="selector-arrow">▼</span>
            </div>

            <button 
                className={`btn-action ${isRunning ? 'running' : 'idle'}`}
                onClick={iniciarRobo}
                disabled={isRunning}
            >
                {isRunning ? (
                    <><Icons.Stop /> Processando...</>
                ) : <><Icons.Play /> Iniciar Motor CRM</>}
            </button>
        </div>
      </div>

      {/* ================= KPI METRICS ================= */}
      <div className="metrics-grid">
         <div className="metric-card">
            <div className="mc-top">
                <span className="mc-label">Contratos Analisados</span>
                <div className="mc-icon bg-blue-soft text-blue"><Icons.Scan /></div>
            </div>
            <span className="mc-value">{stats.analisados}</span>
         </div>
         <div className="metric-card">
            <div className="mc-top">
                <span className="mc-label">Mensagens Entregues</span>
                <div className="mc-icon bg-emerald-soft text-emerald"><Icons.Success /></div>
            </div>
            <span className="mc-value">{stats.enviados}</span>
         </div>
         <div className="metric-card">
            <div className="mc-top">
                <span className="mc-label">Fora do Gatilho / Ignorados</span>
                <div className="mc-icon bg-slate-soft text-slate"><Icons.Skip /></div>
            </div>
            <span className="mc-value">{stats.ignorados}</span>
         </div>
         <div className="metric-card">
            <div className="mc-top">
                <span className="mc-label">Falhas de Roteamento</span>
                <div className="mc-icon bg-red-soft text-red"><Icons.Error /></div>
            </div>
            <span className="mc-value">{stats.erros}</span>
         </div>
      </div>

      {/* ================= ACTIVITY FEED ================= */}
      <div className="feed-wrapper">
        <div className="feed-header">
            <h3>Feed de Operações - {lojaSelecionada === 'Todas' ? 'Global' : lojaSelecionada}</h3>
            <span className={`status-badge ${isRunning ? 'live' : 'offline'}`}>
                {isRunning ? '• Varredura Ao Vivo' : 'Standby'}
            </span>
        </div>
        
        <div className="feed-body">
            {logs.length === 0 ? (
                <div className="feed-empty">
                    <div className="empty-radar"><Icons.Radar /></div>
                    <h3>Motor Aguardando</h3>
                    <p>Selecione a loja e clique em Iniciar para começar a automação.</p>
                </div>
            ) : (
                <div className="timeline-container">
                    {logs.map((log, index) => {
                        const ui = getEventUI(log.tipo);
                        const cleanMsg = log.msg.replace(/^[^\w\[\(]+/, '').trim();

                        return (
                        <div key={index} className="timeline-item animate-slide-up">
                            <div className="timeline-node-area">
                                <div className="timeline-line"></div>
                                <div className={`timeline-node bg-${ui.color}`}>
                                    {ui.icon}
                                </div>
                            </div>
                            
                            <div className={`timeline-card border-${ui.color}`}>
                                <div className="tc-header">
                                    <span className={`tc-badge text-${ui.color} bg-${ui.color}-soft`}>
                                        {ui.label}
                                    </span>
                                    <span className="tc-time">{log.hora}</span>
                                </div>
                                <p className="tc-message">{cleanMsg}</p>
                                
                                {log.imagem && (
                                    <div 
                                        className="tc-evidence" 
                                        onClick={() => setSelectedImage(log.imagem)}
                                        title="Ver anexo"
                                    >
                                        <img src={log.imagem} alt="Anexo do cliente" />
                                        <div className="tc-zoom-layer"><Icons.Zoom /> Ver Imagem</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        );
                    })}
                    
                    {isRunning && (
                        <div className="timeline-item">
                            <div className="timeline-node-area">
                                <div className="timeline-line"></div>
                                <div className="timeline-node bg-slate pulse-node"></div>
                            </div>
                            <div className="timeline-card loading-card">
                                <div className="skeleton-line w-1/3"></div>
                                <div className="skeleton-line w-2/3"></div>
                            </div>
                        </div>
                    )}
                    <div ref={feedEndRef} style={{height: 10}} />
                </div>
            )}
        </div>
      </div>

      {/* ================= LIGHTBOX ================= */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={() => setSelectedImage(null)}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={() => setSelectedImage(null)}><Icons.Close /></button>
                <img src={selectedImage} alt="Detalhe Expandido" />
            </div>
        </div>
      )}

      {/* ================= STYLES ================= */}
      <style>{`
        :root {
            --navy: #0f172a; --slate: #64748b; --slate-light: #f1f5f9; --border: #e2e8f0;
            --blue: #3b82f6; --emerald: #10b981; --red: #ef4444; --purple: #8b5cf6;
            
            --bg-blue-soft: #eff6ff; --bg-emerald-soft: #ecfdf5; 
            --bg-red-soft: #fef2f2; --bg-slate-soft: #f8fafc; --bg-purple-soft: #f5f3ff;
        }

        .crm-robot-container {
            display: flex; flex-direction: column; gap: 24px;
            font-family: 'Plus Jakarta Sans', sans-serif; height: 100%;
        }

        /* --- HERO HEADER --- */
        .robot-header {
            background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
            border-radius: 20px; padding: 32px; color: #fff;
            display: flex; justify-content: space-between; align-items: center;
            box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.3);
            flex-wrap: wrap; gap: 20px; position: relative; overflow: hidden;
        }
        .robot-header::after { 
            content: ''; position: absolute; top: 0; right: 0; width: 300px; height: 300px;
            background: radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%);
            transform: translate(30%, -30%); pointer-events: none;
        }

        .rh-left { display: flex; flex-direction: column; gap: 8px; z-index: 1; }
        .rh-brand { display: flex; align-items: center; gap: 16px; }
        .rh-right { display: flex; align-items: center; gap: 12px; z-index: 2; flex-wrap: wrap; }
        
        .brand-tag { font-size: 10px; font-weight: 800; letter-spacing: 1px; color: #93c5fd; text-transform: uppercase; background: rgba(59,130,246,0.2); padding: 4px 8px; border-radius: 6px; }
        .rh-left h2 { font-size: 26px; font-weight: 700; margin: 4px 0 0 0; letter-spacing: -0.5px; }
        .rh-left p { font-size: 14px; color: #94a3b8; margin: 0; max-width: 500px; line-height: 1.5; }

        /* RADAR ANIMATION */
        .radar-indicator { position: relative; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.05); border-radius: 50%; border: 1px solid rgba(255,255,255,0.1); }
        .radar-core { width: 12px; height: 12px; background: #64748b; border-radius: 50%; transition: 0.3s; }
        .radar-wave { position: absolute; inset: 0; border-radius: 50%; border: 2px solid var(--blue); opacity: 0; }
        
        .radar-indicator.active .radar-core { background: var(--blue); box-shadow: 0 0 10px var(--blue); }
        .radar-indicator.active .radar-wave { animation: radarPulse 2s infinite cubic-bezier(0.4, 0, 0.2, 1); }

        @keyframes radarPulse {
            0% { transform: scale(0.5); opacity: 0.8; }
            100% { transform: scale(1.5); opacity: 0; }
        }

        /* STORE SELECTOR - ESTILO DARK INTEGRADO */
        .store-selector {
            position: relative;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 12px;
            display: flex;
            align-items: center;
            height: 48px;
            overflow: hidden;
            transition: 0.2s;
        }
        .store-selector:hover { background: rgba(255, 255, 255, 0.15); border-color: rgba(255, 255, 255, 0.4); }
        .store-selector.disabled { opacity: 0.6; cursor: not-allowed; }
        
        .selector-icon {
            padding-left: 12px;
            color: #94a3b8;
            display: flex;
            align-items: center;
        }
        .store-selector select {
            background: transparent;
            border: none;
            color: #fff;
            padding: 0 32px 0 12px;
            height: 100%;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            appearance: none;
            outline: none;
            min-width: 140px;
        }
        .store-selector select option {
            background: #0f172a;
            color: #fff;
            padding: 10px;
        }
        .selector-arrow {
            position: absolute;
            right: 12px;
            color: #94a3b8;
            font-size: 10px;
            pointer-events: none;
        }

        /* ACTION BUTTON */
        .btn-action {
            height: 48px;
            padding: 0 24px; border-radius: 12px; font-size: 14px; font-weight: 700;
            display: flex; align-items: center; gap: 10px; border: none; cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); white-space: nowrap;
        }
        .btn-action.idle { background: #fff; color: var(--navy); box-shadow: 0 4px 14px rgba(0,0,0,0.2); }
        .btn-action.idle:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.3); }
        .btn-action.running { background: rgba(255,255,255,0.1); color: #fff; border: 1px solid rgba(255,255,255,0.2); cursor: not-allowed; animation: pulseGlow 2s infinite; }

        @keyframes pulseGlow { 0% { box-shadow: 0 0 0 0 rgba(255,255,255,0.2); } 70% { box-shadow: 0 0 0 10px rgba(255,255,255,0); } 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0); } }

        /* --- METRICS GRID --- */
        .metrics-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        .metric-card { background: #fff; border: 1px solid var(--border); border-radius: 16px; padding: 20px; box-shadow: 0 2px 10px -4px rgba(0,0,0,0.05); display: flex; flex-direction: column; gap: 12px; transition: 0.2s; }
        .metric-card:hover { border-color: #cbd5e1; transform: translateY(-2px); box-shadow: 0 10px 20px -5px rgba(0,0,0,0.05); }
        
        .mc-top { display: flex; justify-content: space-between; align-items: flex-start; }
        .mc-label { font-size: 12px; font-weight: 600; color: var(--slate); max-width: 100px; line-height: 1.3; }
        .mc-icon { width: 40px; height: 40px; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
        .mc-value { font-size: 32px; font-weight: 800; color: var(--navy); line-height: 1; letter-spacing: -1px; }

        /* --- ACTIVITY FEED --- */
        .feed-wrapper { background: #fff; border: 1px solid var(--border); border-radius: 20px; display: flex; flex-direction: column; flex: 1; min-height: 400px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02); overflow: hidden; }
        .feed-header { padding: 20px 24px; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; background: #fafaf9; }
        .feed-header h3 { font-size: 16px; font-weight: 700; color: var(--navy); margin: 0; }
        
        .status-badge { font-size: 12px; font-weight: 600; padding: 6px 12px; border-radius: 20px; }
        .status-badge.live { background: #fef2f2; color: #ef4444; animation: blinker 2s linear infinite; }
        .status-badge.offline { background: var(--slate-light); color: var(--slate); }
        @keyframes blinker { 50% { opacity: 0.6; } }

        .feed-body { flex: 1; overflow-y: auto; padding: 24px; background: #f8fafc; }
        .feed-body::-webkit-scrollbar { width: 6px; }
        .feed-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Empty State */
        .feed-empty { height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; color: var(--slate); padding: 40px; }
        .empty-radar { width: 64px; height: 64px; background: #e2e8f0; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #94a3b8; margin-bottom: 16px; }
        .feed-empty h3 { font-size: 18px; color: var(--navy); margin: 0 0 8px 0; }
        .feed-empty p { font-size: 14px; max-width: 300px; line-height: 1.5; }

        /* TIMELINE LAYOUT */
        .timeline-container { display: flex; flex-direction: column; gap: 0; }
        .timeline-item { display: flex; gap: 16px; position: relative; }
        
        .timeline-node-area { display: flex; flex-direction: column; align-items: center; width: 40px; position: relative; }
        .timeline-line { position: absolute; top: 32px; bottom: -16px; width: 2px; background: #e2e8f0; left: 50%; transform: translateX(-50%); z-index: 1; }
        .timeline-item:last-child .timeline-line { display: none; } 
        
        .timeline-node { width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; z-index: 2; margin-top: 4px; box-shadow: 0 0 0 4px #f8fafc; }
        .pulse-node { animation: scalePulse 1.5s infinite; }
        @keyframes scalePulse { 0% { transform: scale(0.8); opacity: 0.5; } 50% { transform: scale(1); opacity: 1; } 100% { transform: scale(0.8); opacity: 0.5; } }

        .timeline-card { flex: 1; background: #fff; border: 1px solid var(--border); border-radius: 12px; padding: 16px; margin-bottom: 16px; box-shadow: 0 2px 4px rgba(0,0,0,0.02); transition: 0.2s; border-left-width: 4px; }
        .timeline-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.05); }
        
        .tc-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
        .tc-badge { font-size: 10px; font-weight: 700; text-transform: uppercase; padding: 4px 8px; border-radius: 6px; letter-spacing: 0.5px; }
        .tc-time { font-size: 12px; color: #94a3b8; font-weight: 500; }
        .tc-message { font-size: 14px; color: var(--navy); line-height: 1.5; margin: 0; }

        .loading-card { display: flex; flex-direction: column; gap: 12px; padding: 20px 16px; border-left-color: #cbd5e1 !important; }
        .skeleton-line { height: 12px; background: #e2e8f0; border-radius: 6px; animation: skeletonPulse 1.5s infinite; }
        .w-1\/3 { width: 33%; } .w-2\/3 { width: 66%; }
        @keyframes skeletonPulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }

        .tc-evidence { margin-top: 12px; width: 120px; height: 80px; border-radius: 8px; overflow: hidden; position: relative; cursor: zoom-in; border: 1px solid var(--border); background: #f1f5f9; }
        .tc-evidence img { width: 100%; height: 100%; object-fit: cover; transition: 0.3s; }
        .tc-zoom-layer { position: absolute; inset: 0; background: rgba(15,23,42,0.6); display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; font-size: 10px; font-weight: 600; gap: 4px; opacity: 0; transition: 0.2s; }
        .tc-evidence:hover img { transform: scale(1.05); }
        .tc-evidence:hover .tc-zoom-layer { opacity: 1; }

        .lightbox-overlay { position: fixed; inset: 0; background: rgba(15,23,42,0.95); backdrop-filter: blur(8px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; animation: fadeIn 0.2s; }
        .lightbox-content { position: relative; max-width: 90vw; max-height: 90vh; }
        .lightbox-content img { max-width: 100%; max-height: 90vh; object-fit: contain; border-radius: 8px; box-shadow: 0 20px 50px rgba(0,0,0,0.5); animation: scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
        .close-btn { position: absolute; top: -40px; right: -40px; background: rgba(255,255,255,0.1); border: none; color: #fff; cursor: pointer; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
        .close-btn:hover { background: rgba(255,255,255,0.2); transform: scale(1.1); }

        /* Utils & Colors */
        .bg-blue { background-color: var(--blue); } .text-blue { color: var(--blue); } .border-blue { border-left-color: var(--blue); } .bg-blue-soft { background-color: var(--bg-blue-soft); }
        .bg-emerald { background-color: var(--emerald); } .text-emerald { color: var(--emerald); } .border-emerald { border-left-color: var(--emerald); } .bg-emerald-soft { background-color: var(--bg-emerald-soft); }
        .bg-red { background-color: var(--red); } .text-red { color: var(--red); } .border-red { border-left-color: var(--red); } .bg-red-soft { background-color: var(--bg-red-soft); }
        .bg-slate { background-color: var(--slate); } .text-slate { color: var(--slate); } .border-slate { border-left-color: var(--slate); } .bg-slate-soft { background-color: var(--bg-slate-soft); }
        .bg-purple { background-color: var(--purple); } .text-purple { color: var(--purple); } .border-purple { border-left-color: var(--purple); } .bg-purple-soft { background-color: var(--bg-purple-soft); }

        .animate-fade-in { animation: fadeIn 0.4s ease-out; }
        .animate-slide-up { animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes scaleIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }

        /* --- RESPONSIVE MOBILE --- */
        @media (max-width: 1024px) {
            .metrics-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 768px) {
            .robot-header { padding: 24px; flex-direction: column; align-items: flex-start; }
            .rh-right, .btn-action { width: 100%; justify-content: center; }
            .rh-left h2 { font-size: 22px; }
            
            .store-selector { width: 100%; margin-bottom: 12px; }
            .store-selector select { width: 100%; }

            .metrics-grid { grid-template-columns: 1fr 1fr; gap: 12px; }
            .metric-card { padding: 16px; }
            .mc-value { font-size: 24px; }
            
            .feed-wrapper { min-height: 500px; border-radius: 12px; }
            .timeline-item { gap: 12px; }
            .timeline-node-area { width: 24px; }
            .timeline-node { width: 24px; height: 24px; }
            .timeline-node svg { width: 12px; height: 12px; }
            .timeline-line { top: 24px; }
            .tc-message { font-size: 13px; }
            
            .lightbox-content img { max-width: 100vw; border-radius: 0; }
            .close-btn { top: 10px; right: 10px; background: rgba(0,0,0,0.5); }
        }
      `}</style>
    </div>
  );
}